import { Reducer } from "redux";

import { UserDetailsResponse } from "../models/api/User";
import { UserDetailsActionTypes } from "../models/dispatchTypes/User";
import { UserListActionDispatchTypes } from "../constants/User";

const initialState: UserDetailsResponse = {
  loading: false,
  response: {
    searchResponse: [
      {
        userId: "",
        firstName: "",
        lastName: "",
        email: "",
        status: "",
        approver: null,
        roleType: "",
      },
    ],
    totalRows: 0,
  },

  error: null,
};

const UserListReducer: Reducer<UserDetailsResponse, UserDetailsActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UserListActionDispatchTypes.USER_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UserListActionDispatchTypes.USER_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UserListActionDispatchTypes.USER_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
        response: action.response,
        loading: false,
      };
    }
    case UserListActionDispatchTypes.USER_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserListReducer;
